export const it = {
  downloadByLinksHooks: {
    errorTitle: "Errore",
    errorMessage: "Non è stato possibile scaricare il file {name}",
  },
  checkBrowser: {
    title: "Browser non supportato",
    message:
      "Registrati utilizzando uno dei seguenti browser: Chrome, Safari, Edge o Firefox.",
  },
};
